import React from 'react';
const testimonials = [{
  name: 'Alessandro P.',
  role: 'Liceo Scientifico, Roma',
  rating: 5,
  quote: 'Ho finalmente recuperato le mie serate. Le slide sulle derivate hanno illuminato i miei ragazzi della quinta. Indispensabile.',
  initial: 'A'
}, {
  name: 'Lucia M.',
  role: 'Scuola Media, Napoli',
  rating: 5,
  quote: 'Il soluzionario è oro puro. Non devo più risolvere tutto a mano la sera prima. La classe di terza media ora segue con un entusiasmo mai visto.',
  initial: 'L'
}, {
  name: 'Elena F.',
  role: 'Docente di Ruolo, Milano',
  rating: 5,
  quote: 'Appena scaricato, usato il giorno dopo. La programmazione è perfetta e i materiali per BES/DSA sono utilissimi. Grazie Edulabs!',
  initial: 'E'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div className="text-center mb-12" data-id="element-240">
          <span className="inline-block bg-secondary/10 text-secondary border border-secondary/20 font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-4 tracking-wider uppercase" data-id="element-241">
            ⭐ Recensioni Verificate
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-242">
            Cosa dicono i docenti
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-3" data-id="element-243">
            Oltre <span className="text-primary font-bold" data-id="element-244">800 docenti</span>{' '}
            italiani hanno già scelto Matematica Pronta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-245">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-246">
              <div className="text-secondary text-lg" aria-label={`${t.rating} stelle`} data-id="element-247">
                {'⭐'.repeat(t.rating)}
              </div>
              <p className="text-text-main text-base leading-relaxed font-medium italic flex-1" data-id="element-248">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-249">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-orange-600 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-250">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-251">
                  <p className="text-text-main font-bold text-sm" data-id="element-252">{t.name}</p>
                  <p className="text-text-sec text-xs leading-tight" data-id="element-253">
                    {t.role}
                  </p>
                </div>
                <span className="ml-auto text-check-green text-[10px] font-bold uppercase tracking-wider flex items-center gap-1 flex-shrink-0" title="Acquisto verificato" data-id="element-254">
                  ✓
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}